import { ThemeColors } from '../theme/ThemeColors';
import { StateInterface } from '../store';
import { Store } from 'vuex';
import { Device, DeviceInfo } from '@capacitor/device';
import { StatusBar, Style } from '@capacitor/status-bar';
import { App, AppInfo } from '@capacitor/app';

export default class ThemeInitializer {
  static async Initialize(store: unknown): Promise<void> {
    const deviceInfo: DeviceInfo = await Device.getInfo();
    const isMobile = deviceInfo.platform === 'ios' || deviceInfo.platform === 'android';

    const appInfo: AppInfo | null = isMobile ? await App.getInfo() : null;

    const company = ThemeInitializer.GetCompany(appInfo, isMobile);

    ThemeColors.setCompanyColorTheme(company, !isMobile);

    if (deviceInfo.platform === 'ios') {
      await StatusBar.setStyle({
        style: Style.Dark
      });
    } 

    const typedStore = store as Store<StateInterface>;

    if (typedStore) {
      void typedStore.dispatch('setting/setCompany', company);
      typedStore.commit('setting/setPlatform', deviceInfo.platform);
    }
  }

  static GetCompany(appInfo: AppInfo | null, isMobile: boolean) {
    if (isMobile && appInfo) {
      return ThemeInitializer.getCompanyFromAppId(appInfo);
    }

    return ThemeInitializer.getCompanyFromUrl();
  }

  private static getCompanyFromAppId(appInfo: AppInfo) {
    const appIdParts = appInfo.id.split('.');
    const company = appIdParts[appIdParts.length - 1];

    return company.toUpperCase();
  }

  private static getCompanyFromUrl() {
    const url = window.location.href;

    if (process.env.CRV_URL && url.startsWith(process.env.CRV_URL)) {
      return 'CRV';
    }

    if (process.env.DRV_URL && url.startsWith(process.env.DRV_URL)) {
      return 'DRV'
    }

    // fallback to HRV
    return 'HRV';
  }
}
